export default __webpack_public_path__ + "static/media/I0003.4cb258b4.png";